/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled, use, useCallback } from 'fierry/react';

import Route from 'solis/route';
import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';

import Args from 'solis/claude/action/args';

import useBoardContext from 'solis/claude/action/context/board';

import { getMatchingSourceColony, getSourceCandidates } from 'solis/claude/action/source.colony';


const Container = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  box-shadow: 0 0 0 1px var(--gray-a5);
`;


const Segment = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 18px;
  border: none;
  background: var(--gray-3);
  color: var(--gray-12);
  font: inherit;
  font-size: var(--font-size-2);
  letter-spacing: 0.02em;
  cursor: pointer;

  &:first-child { border-radius: 9999px 0 0 9999px; }
  &:last-child { border-radius: 0 9999px 9999px 0; }

  &:hover { background: var(--gray-5); }
  &:active { background: var(--gray-6); }

  &:disabled {
    color: var(--gray-a7);
    cursor: default;
  }

  &:disabled:hover { background: var(--gray-3); }
  &:disabled:active { background: var(--gray-3); }

  ${props => props.$selected && css`
    position: relative;
    z-index: 1;
    background: var(--accent-4);
    box-shadow: 0 0 0 1px var(--accent-11);
    cursor: default;

    &:hover { background: var(--accent-6); }
    &:active { background: var(--accent-6); }
  `}
`;


const OPTIONS =
[
  { value: Routes.DashboardBoard,     label: 'View',      isEnabled: () => true },
  { value: Routes.DashboardInfluence, label: 'Influence', isEnabled: (board, account) => getSourceCandidates(board, account).length > 0 },
];


const OnChange = (value, dispatch, board, account, zone) =>
{
  const args = {};

  if (zone !== null)
  {
    args[Args.BoardZone] = zone.getAbsoluteHex().toString();
  }

  if (value === Routes.DashboardInfluence)
  {
    args[Args.SourceColony] = getMatchingSourceColony(board, account, zone).cass.id;
  }

  dispatch.pushForeground({ route: value.replace(':id', board.cass.id), args });
};


export default () =>
{
  const route = use(Route);

  const dispatch = use(Navigation.Dispatch);

  const { board, zone, account } = useBoardContext();

  const onChange = useCallback(OnChange, [ dispatch, board, account, zone ]);

  const onPick = (value) => () =>
  {
    onChange(value);
  };

  return (
    <Container>
      {OPTIONS.map(option =>
      {
        const selected = route.isType(option.value);
        const disabled = !option.isEnabled(board, account);

        return (
          <Segment key = {option.value} type = 'button' $selected = {selected} disabled = {disabled} onClick = {selected ? null : onPick(option.value)}>
            {option.label}
          </Segment>
        );
      })}
    </Container>
  );
};
